import React, { createContext, useContext, ReactNode } from 'react';
import { useSipCall, UseSipCallReturn } from 'utils/hooks/useSipCall';

const SipCallContext = createContext<UseSipCallReturn | null>(null);

export const useSipCallContext = () => {
  const context = useContext(SipCallContext);
  if (!context) {
    throw new Error('useSipCallContext must be used within SipCallProvider');
  }
  return context;
};

export const SipCallProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const sipCall = useSipCall();

  return (
    <SipCallContext.Provider value={sipCall}>
      {children}
    </SipCallContext.Provider>
  );
};
